import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductCartUpdatePage = lazy(() => import('../views/update/AccountProductCartUpdatePage'));

export function AccountProductCartUpdatePageLazy() {
	return (
		<PageSuspense>
			<AccountProductCartUpdatePage />
		</PageSuspense>
	);
}
